export const getAllItems = (notificationObject) => {
  const itemsArray = Object.values(notificationObject).flatMap((group) =>
    group.items.map((item) => item),
  );

  return itemsArray;
};
